'use client';

import styles from './Header.module.css';

/**
 * Backoffice login icon - subtle link to manager login
 * External link with proper security attributes
 */
export function BackofficeIcon() {
  return (
    <a
      href="https://manage.jamezz.com/manager/login"
      target="_blank"
      rel="noopener noreferrer nofollow"
      className={styles.backofficeLink}
      aria-label="Backoffice Login"
      title="Backoffice Login"
    >
      <svg 
        viewBox="0 0 24 24" 
        className={styles.backofficeIcon}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient id="backoffice-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" style={{ stopColor: '#FF9966', stopOpacity: 1 }} />
            <stop offset="100%" style={{ stopColor: '#FF5E62', stopOpacity: 1 }} />
          </linearGradient>
        </defs>
        {/* User circle */}
        <circle cx="12" cy="8" r="3" />
        <path d="M6 21c0-3.3 2.7-6 6-6s6 2.7 6 6" />
        {/* Login arrow */}
        <path d="M18 12h4m0 0l-2-2m2 2l-2 2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </a>
  );
}



